import React from 'react';
import api from '../apiConnector'

import FrontTarifs from './tarifs';
import FrontOptions from './options'
import FrontProgress from './progress';
import FieldSelect from './fields/fieldSelect';
import img_horloge from '../img/Horloge.svg'
import FrontPeriodicite from './periodicite';
import FrontRecap,{CbLogos} from './recap';
import woman from '../img/femme.png'
import RecapUnfoldVehicule from './recapUnfoldVehicule';
import RecapUnfoldYou from './recapUnfoldYou';

const showAxa = process.env.REACT_APP_SHOW_AXA === 'true'
const showFma = process.env.REACT_APP_SHOW_FMA === 'true'

export default class FrontLanding extends React.Component {
    
    constructor(props) {
        super(props);
        this.refRecap = React.createRef()
        this.timer = false
        this.state = {
            collapseEcheancier:true,
            isMobile: false
        }
    }

    periodic() {
        const calculating = this.props.devis.axa?.calculating
        if ( calculating ) {
            this.props.checkStatus({'axa.calculating':calculating})
        }
    }

    mediaQueryList = null;

    handleMediaChange = (e) => {
        this.setState({ isMobile: e.matches });
    };

    componentDidMount() {
        this.timer = setInterval(
            this.periodic.bind(this),
            2000
        )
        this.mediaQueryList = window.matchMedia('(max-width: 60rem)');
        this.setState({ isMobile: this.mediaQueryList.matches });
        this.mediaQueryList.addEventListener('change', this.handleMediaChange)

        this.componentDidUpdate()
    }

    componentWillUnmount() {
        if ( this.timer ) {
            clearInterval( this.timer )
            this.timer = false
        }
        if (this.mediaQueryList) {
            this.mediaQueryList.removeEventListener('change', this.handleMediaChange);
        }
    }


    onSubmit() {
        const branch = this.props.lastBranch || this.props.devis.tb
        switch ( branch ) {
            case 'axa':
                this.props.setPage( 'details2')
                break
            case 'xena':
            default:
                this.props.setPage( 'details1')
                break
        }
    }

    goToRecap() {
        this.refRecap.current?.scrollIntoView({behavior:'smooth'})
    }

    componentDidUpdate() {
        /*
        if ( ! this.props.devis.validated ) {
            this.props.validateDevis()
        }
        */
    }

    render() {
        const devis = this.props.devis
        const isMoto = devis.type == 'moto'
        const params = devis.params
        const {best_match:bestMatch} = params
        const comparateur = ! bestMatch
        const solly = devis.getSolly()
        const axa = devis.getAxa().setChoicesFromDevis().swithToDeprecatedOnError().setFancy('-',' €')
        const axaIsDeprecated = axa.deprecated
        const fma = devis.getFma().setChoicesFromDevis().swithToDeprecatedOnError().setFancy('-',' €')
        const xena = params.error ? [] :( params.warranties||[] )

        const candidates = [
        { id: 'xena',  check: xena.length !== 0, price: devis.toPayYearly(true,true,'M2') },
        { id: 'fma',   check: showFma && fma.hasFma(), price: fma.annuel('M2') },
        { id: 'axa',   check: showAxa && axa.hasAxa(), price: axa.hasTarifs('M2') ? axa.annuel('M2') : false },
        { id: 'solly', check: solly.hasSolly(), price: solly.hasTarifs('M2') ? solly.annuel('M2') : false }
        ];

        // Get the IDs of the first two that pass the check
        const activeIds = candidates
        .filter(item => item.check)
        .sort( (a,b)=>(!a.price) ? 1 : (!b.price) ? -1 : a.price-b.price )
        .slice(0, this.state.isMobile ? 2 : 4 )
        .map(item => item.id);

        // Now you can check for specific ones easily
        const hasXena  = activeIds.includes('xena');
        const hasFma   = activeIds.includes('fma');
        const hasAxa   = activeIds.includes('axa');
        const hasSolly = activeIds.includes('solly');

        const container = {
            solly:solly,
            axa:axa,
            xena:xena,
            fma:fma,
            bestMatch:bestMatch,
            comparateur:comparateur||this.props.embeded,
            hasXena:hasXena,
            hasSolly:hasSolly,
            hasAxa:hasAxa,
            hasFma:hasFma,
            devis:this.props.devis,
            changeParams:this.props.changeParams,
            setPage: this.props.setPage,
            enableClientSubscription: this.props.enableClientSubscription,
            focusError: ()=>{}
        }
/*
        const toPay = devis.toPay()
        const toPayYearly = devis.toPayYearly()
        const selectedOptions = devis.getValue('selectedOptions',[])
        const periodicite = devis.getValue('periodicite')
*/
        const subscribeButton = this.props.enableClientSubscription
        ?<p>
            <a className="button button_subscribe" onClick={()=>this.props.setPage('details1')}>
                Souscrivez en ligne en 2&nbsp;minutes&nbsp;<span>▸</span>
            </a>
        </p>
        :<><a className="button button_subscribe">La souscription en ligne est temporairement fermée.</a></>
        const subscribeButtonShort = this.props.enableClientSubscription
        ?<a className="button button_devis yellow" onClick={()=>this.props.setPage('details1')}>
            Souscrire&nbsp;<span>▸</span>
        </a>
        :<></>

        return <>
        <FrontProgress onSubmit={this.onSubmit.bind(this)} lastBranch={this.props.lastBranch || this.props.devis.tb} comparateursCompleted={params.comparateursCompleted} setPage={this.props.setPage} page={this.props.page} topRef={this.props.topRef}/>
        <div className="container narrow">
            <div className="contentbox front_form">
                <div className="contentvbox">
                    {this.props.enableClientSubscription?'':<><br/>{subscribeButton}<p className="error">Réouverture à 9h demain matin. N'hésitez pas à nous contacter au <br/><a href="tel:0974772861">09 74 77 28 61</a></p></>}
                    { this.props.embeded
                    ? <FieldSelect 
                            field="frais_sup" container={container} options={devis.getOptionsFraisSup(api.isAdmin())} 
                            label={<>Les frais de base pour ce type de véhicule sont de <b>{devis.params.frais} €</b>.<br/>Vous pouvez appliquer des frais supplémentaires, dans la limite de {devis.max_frais}€ de frais totaux :</>}
                        /> : ''}

                    <h2>Je souhaite <b>régler</b> en&nbsp;:</h2>
                    <FrontPeriodicite container={container}/>
                    <h2>Comparez nos offres & choisissez votre <b>formule</b></h2>
                    <FrontTarifs container={container}/>
                    <h2>Choisissez vos options</h2>
                    <FrontOptions container={container}/>
                    
                </div>
                <div className="contentvbox">                
                    
                    <h1>Choisissez votre offre & souscrivez</h1>
                    <h4>Bonne nouvelle ! Il ne vous reste plus que <b><img src={img_horloge}/> 1 minute</b> avant de souscrire votre véhicule</h4>

                    <FrontRecap enableClientSubscription={this.props.enableClientSubscription} devis={container.devis} axaAlive={this.props.axaAlive} setPage={this.props.setPage} hasAxa={hasAxa} axa={axa} hasSolly={hasSolly} hasXena={hasXena} fma={fma} hasFma={hasFma} comparateur={container.comparateur} bestMatch={bestMatch}/>

                    <div className="notice_woman_box">
                        <div>
                            <b>À noter !</b> Le paiement annuel est effectué en <i>une seule fois</i>. En revanche, le
                            paiement mensuel comprend un <i>versement initial</i> lors de la souscription,
                            incluant <i>un mois d'assurance</i> ainsi que les <i>frais de gestion et de courtage,</i>
                            suivis de onze prélèvements mensuels. Les frais de gestion et de courtage
                            sont <i>renouvelables et non remboursables</i>.
                        </div>
                        <div>
                            <img src={woman}/>
                        </div>
                    </div>
                </div>

                <div className="recap_unfold_container">
                    <RecapUnfoldYou devis={devis} setPage={this.props.setPage}/>
                    <RecapUnfoldVehicule devis={devis} setPage={this.props.setPage}/>
                </div>

            </div>


            </div>

        </>
    }
}